"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var buttonSubmitStyles_1 = require("./buttonSubmitStyles");
var Translation_1 = require("../../../common/components/presentation/Translation/Translation");
var JourneyTypes_1 = require("../../../../../common/enum/JourneyTypes");
var ButtonSubmit = function (_a) {
    var disabled = _a.disabled, journeyType = _a.journeyType;
    var styles = buttonSubmitStyles_1.default();
    var translationId = '';
    if (journeyType === JourneyTypes_1.JourneyTypes.CONTINUE_IN_DEALERSHIP) {
        translationId = 'enquiryForm.button.submit';
    }
    else if (journeyType === JourneyTypes_1.JourneyTypes.RESERVE_ONLINE) {
        translationId = 'enquiryForm.button.submitReserveOnline';
    }
    return (<core_1.Box className={styles.submitButtonContainer}>
      <core_1.Button type="submit" disabled={disabled} className={styles.submitButton} classes={{ contained: styles.btnContained }} variant="contained" color="primary" data-test="button:enquiry_form:submit">
        <Translation_1.default id={translationId}/>
      </core_1.Button>
    </core_1.Box>);
};
exports.default = ButtonSubmit;
